module.exports = __webpack_public_path__ + "images/createListBg.4374f236.svg";